<template>
  <div class="row mt-2">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              :to="{ name: 'auditOfficeList'}"
              :class="{ active: $route.name === 'auditOfficeList'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            {{$t('audit.overview')}}
          </router-link>
          <router-link
              :to="{ name: 'auditMonthlyCalendar'}"
              :class="{ active: $route.name === 'auditMonthlyCalendar'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            {{$t('audit.calendar')}}
          </router-link>
          <router-link
              :to="{ name: 'auditWeeklyCalendar'}"
              :class="{ active: $route.name === 'auditWeeklyCalendar'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            {{$t('audit.daily_calendar')}}
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t }   = useI18n();
</script>

<style scoped>

</style>